import i18n from './i18n'
import './styles/antd.less'
import './styles/atomic.scss'
import './styles/globals.scss'
import './styles/index.scss'
import { ActiveUserProvider } from 'activeUser'
import { AuthProvider } from 'auth'
import { AmazLoading } from 'components/atoms'
import { TIME_DELAY_FALLBACK } from 'constants/common'
import { theme } from 'constants/theme'
import { OnlineStatusProvider } from 'detectConnectServer'
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import { store } from 'store'
import { ThemeProvider } from 'styled-components'

const AppPage = lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('./pages'),
    new Promise((resolve) => setTimeout(resolve, TIME_DELAY_FALLBACK))
  ])
  return moduleExports
})

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <ThemeProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <AuthProvider>
            <Suspense fallback={<AmazLoading />}>
              <OnlineStatusProvider>
                <ActiveUserProvider>
                  <AppPage />
                </ActiveUserProvider>
              </OnlineStatusProvider>
            </Suspense>
          </AuthProvider>
        </I18nextProvider>
      </ThemeProvider>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
)
